/* eslint-disable react-hooks/exhaustive-deps */
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { prepareHeaders } from "../user/user.api";
import { PaginationResults, TypeQuery } from "../user/user.type";
import { ApiBaseUrl } from "../../http";
import { QueryUrl, useLocationState } from "../../Utils";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { IMission, MissionFormdata, TimeLineMission } from "./mission.type";
import DashboardApi from "../dashboard/dashboard.api";

const MissionApi = createApi({
  reducerPath: "missionApi",
  tagTypes: ["mission", "missions"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${ApiBaseUrl}/api/`,
    prepareHeaders,
  }),
  endpoints: (build) => ({
    AddOrUpdateMission: build.mutation<
      IMission,
      { slug?: string; data: IMission | FormData | Partial<IMission> }
    >({
      query: ({ slug, data }) => ({
        url: slug ? `missions/${slug}/` : `missions/`,
        method: slug ? "PUT" : "POST",
        body: data,
      }),
      invalidatesTags: ["missions", "mission"],
    }),
    getMissions: build.query<PaginationResults<IMission>, TypeQuery>({
      query: (query) => QueryUrl("missions", query),
      providesTags: ["missions"],
    }),
    getMission: build.query<IMission, string>({
      query: (slug) => `missions/${slug}`,
      providesTags: ["mission"],
    }),
    getHistoriqueMission: build.query<IMission, string>({
      query: (slug) => `missions/historiques/${slug}`,
      providesTags: ["mission"],
    }),
    deleteMission: build.mutation<MissionFormdata, string>({
      query: (slug) => ({
        url: `missions/${slug}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["mission", "missions"],
    }),
    // getMissionByPrestataire: build.query<PaginationResults<IPrestataire>, TypeQuery>({
    //     query: ({ slug, ...query }) => QueryUrl(`prestataire/${slug}/missions/`, query),
    //     providesTags: ["prestataire"],
    // }),
    getDureeEstimee: build.query<
      { duree_estimee: string },
      {
        logementSlug: string;
        nb_nuit: number;
        preparationCanapeLit: number;
        delai: string;
        heure_de_debut: string;
        date: string;
        type_mission: string;
        parametres_intervention_count: number;
        voyageurs_entrants: number;
        voyageurs_sortants: number;
      }
    >({
      query: ({
        logementSlug,
        nb_nuit,
        preparationCanapeLit,
        delai,
        heure_de_debut,
        date,
        type_mission,
        parametres_intervention_count,
        voyageurs_entrants,
        voyageurs_sortants
      }) =>
        `mission/tarifs/?nb_nuit=${nb_nuit}&logement=${logementSlug}&preparation_canape_lit=${preparationCanapeLit}&delai=${delai}&heure_de_debut=${heure_de_debut}&date=${date}&type_mission=${type_mission}&parametres_intervention_count=${parametres_intervention_count}&voyageurs_entrants=${voyageurs_entrants}&voyageurs_sortants=${voyageurs_sortants}`,
    }),
    updateMissionPro: build.mutation<
      IMission,
      { professionnel: string; slug: string; }
    >({
      query: ({ slug, ...data }) => ({
        url: `admin/mission/${slug}/changer_pro/`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["mission"],
    }),
    assignProMission: build.mutation<
      IMission,
      { slugMission: string; slugPro: string; }
    >({
      query: ({ slugMission, slugPro }) => ({
        url: `mission/${slugMission}/assigner/${slugPro}/`,
        method: "POST",
      }),
      onCacheEntryAdded: async () => {
        try {
          setTimeout(async () => {
            await DashboardApi.util.invalidateTags(["dashboardPrestation"]);
          }, 1000);
        } catch (error) {
          console.error(error);
        }
      },
      invalidatesTags: ["mission", "missions"],
    }),
    cancelMission: build.mutation<
      IMission,
      string
    >({
      query: (slug) => ({
        url: `mission/${slug}/annuler/`,
        method: "GET",
      }),
      onCacheEntryAdded: async () => {
        try {
          setTimeout(async () => {
            await DashboardApi.util.invalidateTags(["dashboard"]);
          }, 1000);
        } catch (error) {
          console.error(error);
        }
      },
      invalidatesTags: ["mission", "missions"],
    }),
    endMission: build.mutation<
      IMission,
      string
    >({
      query: (slug) => ({
        url: `mission/${slug}/terminer/`,
        method: "GET",
      }),
      onCacheEntryAdded: async () => {
        try {
          setTimeout(async () => {
            await DashboardApi.util.invalidateTags(["dashboard"]);
          }, 1000);
        } catch (error) {
          console.error(error);
        }
      },
      invalidatesTags: ["mission", "missions"],
    }),
    getMissionTimeLine: build.query<
      TimeLineMission[],
      string
    >({
      query: (slug) => `missions/${slug}/timeline/`,
    }),
  }),

});

export default MissionApi;

export const {
  useAddOrUpdateMissionMutation,
  useGetMissionsQuery,
  useGetMissionQuery,
  useDeleteMissionMutation,
  useLazyGetMissionQuery,
  useLazyGetDureeEstimeeQuery,
  useGetHistoriqueMissionQuery,
  useUpdateMissionProMutation,
  useCancelMissionMutation,
  useGetMissionTimeLineQuery,
  useAssignProMissionMutation,
  useEndMissionMutation
} = MissionApi;

export function useMissionFromLocation(): [
  IMission,
  boolean,
  string,
  (id: string) => any
] {
  const itemState = useLocationState<IMission | undefined>(undefined);
  const [item, setItem] = useState(itemState);
  const { slug } = useParams<{ slug: string }>();
  const [findById, { data, isError, isLoading }] = useLazyGetMissionQuery();
  const navigate = useNavigate();

  useEffect(() => {
    if (slug) {
      findById(slug);
    }
  }, [slug]);
  useEffect(() => {
    if (isError && !itemState) {
      navigate(-1);
    }
  }, [isError]);
  useEffect(() => {
    if (data) {
      console.log("data", data);
      setItem(data);
    }
  }, [data]);

  return [item as IMission, isLoading, slug as string, findById];
}
